import React from "react";

import {
  MEDD_MATRIX_GROUP_DEFS,
  MEDD_MATRIX_KEY_ORDER,
  MEDD_MATRIX_ROLE_DEFS,
} from "./relationshipUtils";

const REF_GROUP_ORDER = ["buying", "executives", "influence", "adoption"];

export function ContactRolesReferenceCard() {
  return (
    <div
      className="medd-ref-panel"
      role="region"
      aria-label="Contact roles reference"
    >
      <div className="medd-ref-grid">
        {REF_GROUP_ORDER.map(groupKey => {
          const group = MEDD_MATRIX_GROUP_DEFS[groupKey];
          const roles = MEDD_MATRIX_KEY_ORDER.filter(
            key =>
              key !== "UN" && MEDD_MATRIX_ROLE_DEFS[key]?.group === groupKey
          );
          return (
            <div
              key={groupKey}
              className={`medd-ref-group medd-ref-group--${groupKey}`}
            >
              <div
                className={`medd-ref-group-title medd-ref-group-title--${groupKey}`}
              >
                {group.label}
              </div>
              {roles.map(key => {
                const role = MEDD_MATRIX_ROLE_DEFS[key];
                return (
                  <div key={key} className="medd-ref-role">
                    <span className={`medd medd-${key.toLowerCase()}`}>
                      {key}
                    </span>
                    <div>
                      <div className="medd-ref-role-label">{role.label}</div>
                      {role.desc ? (
                        <div className="medd-ref-role-desc">{role.desc}</div>
                      ) : null}
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ContactRolesReferenceCard;
